export default "__VITE_ASSET__aH9IgLht__"